<template>
  <div class="container-center">
    <h3>What is important to you today?</h3>
    <div class="container">
      <br />
      <div class="container-left">
        <div v-if="discernment.topic_status === 'edit'">
          <Plus class="icon-2x" @click.prevent="editAddLine" />
        </div>
      </div>
      <div class="container-central" v-if="discernment.topic_status === ''">
        <input
          class="start-center"
          type="text"
          :v-model="discernmentTopic"
          @keydown="setTopic"
          placeholder="Give it a try"
          ref="topic"
        />
        <div v-if="levels.length === 0">
          <Forward class="icon-2x" @click.prevent="nextLevel" />
        </div>
        <div :key="'level' + index" v-for="(level, index) in levels">
          What about {{ level }} is important to you?
          <br />
          <Cancel @click.prevent="removeLevel(index)" />
          <input
            :id="'subject' + index"
            type="text"
            @keydown="nextLevel"
            @blur="nextLevel"
            :ref="'subject' + index"
          />
          <!-- <div v-if="levels.length > 0"> -->
          <Forward @click.prevent="nextLevel" />
          <!-- </div> -->
        </div>
        <div class="place-icons">
          <div class="icons-central" v-if="levels.length > 3">
            <Save class="icon-2x icons-save" @click.prevent="save" />
            <Close class="icon-2x icons-clear" @click.prevent="clear" />
          </div>
        </div>
      </div>
      <div
        class="container-central"
        v-else-if="discernment.topic_status === 'edit'"
      >
        Topic:
        <input
          class="start-center"
          type="text"
          :value="discernment.topic"
          @keydown="setTopic"
          placeholder="Give it a try"
        />
        <div
          :key="'level' + index"
          v-for="(level, index) in discernment.document_levelContent"
          :ref="'e' + index"
        >
          <Cancel @click.prevent="removeLevel(index)" />
          <input
            :id="'subject' + index"
            type="text"
            @keydown="nextLevelEdit"
            @blur="noDupes"
            :value="level"
            :ref="'subject' + index"
          />
          <br />
          What about {{ level }} is important to you?
          <br />
        </div>
        <div class="place-icons">
          <Save class="icon-2x icons-save" @click.prevent="saveEdit" />
        </div>
      </div>

      <div
        :id="'summary'"
        class="container-central"
        v-else-if="discernment.topic_status === 'review'"
      >
        <h4>{{ discernment.topic }}</h4>
        <div v-for="(item, index) in discernment.content" :key="index">
          {{ item }}
        </div>
        <div class="place-icons">
          <Print class="icon-2x icons-center" @click.prevent="print" />
          <Pencil class="icon-2x icons-center" @click.prevent="editTopic" />
          <Delete class="icon-2x" @click.prevent="deleteWhy" />
        </div>
      </div>
      <div
        class="container-central"
        v-else-if="discernment.topic_status === 'upload'"
      >
        <p>uploading ...</p>
      </div>
      <div :id="'summary'" class="container-central" v-else>
        <div v-for="(item, index) in discernment.content" :key="index">
          {{ item }}
        </div>
        <div class="place-icons">
          <Print class="icon-2x" @click.prevent="print" />
          <FileUpload class="icon-2x" @click.prevent="saveToCloud" />
          <Pencil class="icon-2x icons-center" @click.prevent="editTopic" />
        </div>
      </div>
      <div class="container-right"></div>
    </div>
  </div>
</template>

<script>
import Cancel from "vue-material-design-icons/Cancel.vue";
import Save from "vue-material-design-icons/Check.vue";
import Close from "vue-material-design-icons/Close.vue";
import Print from "vue-material-design-icons/Printer.vue";
import FileUpload from "vue-material-design-icons/FileUpload.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import Plus from "vue-material-design-icons/PlaylistPlus.vue";
import Delete from "vue-material-design-icons/Delete.vue";
import Forward from "vue-material-design-icons/Forward.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "discerner",
  components: {
    Cancel,
    Save,
    Close,
    Print,
    FileUpload,
    Pencil,
    Plus,
    Delete,
    Forward
  },
  data() {
    return {
      discernmentTopic: "",
      levels: [],
      discernment: {
        content: [],
        topic: "",
        levels: 0,
        created_date: 0,
        revised_date: "null",
        id: "",
        sessionid: "",
        userid: "",
        started_session: "",
        topic_status: "", //'':new, review, edit
        levelContent: [],
        revised: false,
        document_levelContent: []
      },
      duplicate: [
        {
          index: null,
          hasDupes: false
        }
      ]
    };
  },
  mounted() {
    this.listDocuments(this.$cookies.get("dw_id"));
  },
  methods: {
    ...mapActions([
      "saveDocument",
      "listDocuments",
      "updateDocument",
      "deleteDocument"
    ]),
    setTopic(event) {
      this.discernmentTopic = event.target.value;
      if (event.code === "Tab") {
        this.levels.push(event.target.value);
      }
    },
    nextLevel(event) {
      let position = 0;
      let place = "subject" + position;
      if (this.levels.length > 0) {
        position = this.levels.length - 1;
        place = "subject" + position;
        // console.log(place, position);
        // console.log(position, place, event.type, this.$refs[place][0].value);
      }
      if (event.code === "Tab" || event.type === "click") {
        if (event.type === "click") {
          if (this.levels.length === 0) {
            this.levels.push(this.$refs.topic.value);
          } else {
            this.levels.push(this.$refs[place][0].value);
          }
        } else {
          this.levels.push(event.target.value);
        }
        let self = this;
        let seen = [];
        let origin = event.target.id.substring(7);
        this.levels.forEach(index => {
          //   console.log(seen[index], index, event);
          if (seen[index]) {
            alert(`two values cannot be the same`);
            event.target.style.color = "red";
            let err = "subject" + origin;
            // console.log(this.$refs[err]);
            this.$refs[err][0].focus();
            // document.getElementById(event.target.id).focus();
            self.levels.pop();
          } else {
            // origin ++;
            seen[index] = false;
            event.target.style.color = "black";
          }
        });
      }
    },
    noDupes() {},
    nextLevelEdit(event) {
      let position = event.target.id.substring(7);
      let hasDup = null;
      let dupLocation = null;
      hasDup = this.discernment.document_levelContent.some((val, i) => {
        dupLocation = this.discernment.document_levelContent.indexOf(val);
        //   console.log(this.discernment.document_levelContent.indexOf(val) != i);
        return this.discernment.document_levelContent.indexOf(val) != i;
      });
      if (event.code === "Tab") {
        //IMPORTANT TO REMEMBER $set()
        // let self = this;
        if (this.duplicate.length > 0) {
          //already found dupes re test
          // this.duplicate.forEach((element, index) =>{
          //     let corrected = self.discernment.document_levelContent.some(((val, i) =>{
          //     })
          // })
        }
        // console.log("BETTER: ", hasDup, dupLocation);
        if (hasDup) {
          this.duplicate.push({ hasDupes: hasDup, index: dupLocation });
        } else {
          this.duplicate = [
            {
              hasDupes: false,
              index: 0
            }
          ];
        }
        this.discernment.document_levelContent.splice(
          position,
          1,
          event.target.value
        );
      }
    },
    editAddLine() {
      //   console.log("adding line");
      //   let end = this.discernment.document_levelContent.length - 1;
      //   console.log(end);
      // this.$set(this.discernment.document_levelContent,end, '');
      this.discernment.document_levelContent.push("");
      //   console.log(this.discernment.document_levelContent.length);
    },
    removeLevel(idx) {
      //   console.log(idx, this.levels);
      let remove;
      if (this.levels.length > 0) {
        this.levels.forEach((element, index) => {
          if (idx === index) {
            remove = idx;
          }
        });
        this.levels.splice(remove, 1);
      } else {
        this.discernment.document_levelContent.forEach((element, index) => {
          if (idx === index) {
            remove = idx;
          }
        });
        this.discernment.document_levelContent.splice(remove, 1);
      }
    },
    save() {
      //   console.log("SAVE");
      //add duplicate validation

      this.levels.forEach(element => {
        this.discernment.content.push(
          `What about ${element} is important to you?`
        );
      });
      let last = this.levels.length - 1;
      let lid = "subject" + last;
      this.discernment.levelContent = this.levels;
      this.discernment.content.push(`${this.$refs[lid][0].value}`);
      this.discernment.topic = this.discernmentTopic;
      this.discernment.levels = this.levels.length;
      let d = Date.now();
      (this.discernment.id = "id_" + d.toString()),
        (this.discernment.sessionid = this.$cookies.get("session"));
      this.discernment.started_session = this.$cookies.get("started");
      this.discernment.userid = this.$cookies.get("dw_id");
      this.discernment.created_date = d;
      this.discernment.topic_status = "saved";
    },
    saveEdit() {
      //   let self = this;
      let goNo = true;
      let dupId = null;
      if (this.duplicate.length > 0) {
        this.duplicate.forEach(element => {
          if (element.hasDupes) {
            dupId = "subject" + element.index;
            goNo = false;
          }
        });
      }
      if (goNo) {
        this.discernment.content = [];
        // console.log("SAVE EDITS: ");
        this.discernment.document_levelContent.forEach(element => {
          this.discernment.content.push(
            `What about ${element} is important to you?`
          );
        });
        let last = this.discernment.document_levelContent.length - 1;
        // let lid = 'subject'+last;
        this.discernment.levelContent = this.discernment.document_levelContent;
        // console.log(this.$refs[lid]);
        // this.discernment.content.push(`${this.$refs[lid][0].value}`);
        this.discernment.topic = this.discernmentTopic;
        this.discernment.levels = last + 1;
        let d = Date.now();
        // this.discernment.id  = 'id_'+d.toString(),
        // console.log(this.discernment.id);
        this.discernment.sessionid = this.$cookies.get("session");
        this.discernment.started_session = this.$cookies.get("started");
        this.discernment.userid = this.$cookies.get("dw_id");
        this.discernment.revised_date = d;
        this.discernment.revised = true;
        this.discernment.topic_status = "saved";
      } else {
        // console.log(self.$refs);
        this.$nextTick(() => (this.$refs[dupId][0].style = "color:red"));
      }
    },
    clear() {
      //   console.log("CLEAR");
      this.levels = [];
    },
    print() {
      //prints specific css media query
      window.print();
    },
    async saveToCloud() {
      //   if (!this.discernment.revised) {
      this.discernment.topic_status = "upload";
      this.saveDocument(this.discernment)
        .then(() => {
          this.discernment.topic_status = "";
          this.levels = [];
          this.discernment.topic_status = "";
          //   } else {
        })
        .then(() => {
          this.updateDocument(this.discernment)
            .then(() => {
              this.discernment.content = [];
              this.discernment.document_levelContent = [];
              this.discernment.topic_status = "";
              // this.discernment.topic_status = '';
              // this.discernment
            })
            .then(() => {
              this.getAvailableDocuments;
            });
        });
      // console.log(upload);
      // if (upload.status === 200) {

      // }
      //   }
    },
    editTopic() {
      //   console.log("SET THE FORM");
      this.discernment.topic_status = "edit";
    },
    deleteWhy() {
      let submittal = {
        userid: this.$cookies.get("dw_id"),
        started: this.$cookies.get("started"),
        sessionid: this.$cookies.get("session"),
        id: this.discernment.id
      };
      //   console.log(submittal);
      this.deleteDocument(submittal);
      this.discernment.topic_status = "";
      this.getAvailableDocuments;
    }
  },
  computed: {
    ...mapGetters(["getAvailableDocuments", "getDocument"])
  },
  watch: {
    getDocument: function(OV) {
      //   if (this.discernment.content.length` > 0) {
      //     this.discernment.content = [];
      //   }`
      this.discernment.topic_status = "review";
      this.discernment.topic = OV.document_topic;
      // let editContent = OV.document_levelContent.S.split(",");
      //   console.log(typeof OV.document_levelContent);

      this.discernment.document_levelContent = OV.document_levelContent;
      // console.log(editContent);
      // let self = this;
      // editContent.forEach(element => {
      //     if(element[0] === "["){
      //         element = element.substring(1);
      //         console.log("FIRST: ",element);
      //     } else if(element[element.length-1] === "]"){
      //         element = element.substring(0,element.length-1);
      //         console.log("LAST: ",element);
      //     }
      //     self.discernment.document_levelContent.push(element);
      // });
      this.discernment.content = OV.document_content;
      // console.log(typeof content);
      // let contentArray = content.split(",");
      // contentArray.forEach((element) =>{
      //     console.log(element[0]);
      //     if(element[0] === "["){
      //         element = element.substring(1);
      //         console.log("FIRST: ",element);
      //     } else if(element[element.length-1] === "]"){
      //         element = element.substring(0,element.length-1);
      //         console.log("LAST: ",element);
      //     }
      //     self.discernment.content.push(element);
      // })
      //   console.log(OV, NV);
      //   console.log(typeof this.discernment.document_levelContent);
      //   console.log(this.discernment.document_levelContent);
      this.discernment.id = OV.document_id;
      this.discernmentTopic = OV.document_topic;
      return this.discernmentTopic;
    }
  }
};
</script>

<style scoped>
.container {
  display: grid;
  justify-self: center;
  justify-content: center;
  align-self: center;
  grid-template-columns: 2fr 10fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: "leftCol mainCol rightCol";
}
.container-left {
  grid-area: leftCol;
}
.container-central {
  grid-area: mainCol;
  align-items: left;
  text-align: left;
  align-content: left;
}
.container-right {
  grid-area: rightCol;
}
.container-headline {
  grid-column: col 1 / span 4;
}
.material-design-icon.icon-2x {
  height: 2em;
  width: 2em;
}
.material-design-icon.icon-2x > .material-design-icon__svg {
  height: 2em;
  width: 2em;
}
.place-icons {
  grid-area: mainCol;
  justify-content: center;
  display: flex;
}
.icons-central {
  align-items: center;
  justify-content: center !important;
  width: 50%;
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: 1;
  grid-template-areas: "save nothing clear";
}
.icons-center {
  place-items: center;
}
.icons-save {
  place-items: center;
  grid-area: save;
}
.icons-clear {
  place-items: center;
  grid-area: clear;
}
.start-center {
  text-align: center;
  align-items: center;
  align-self: center;
}
</style>
<style>
@media print {
  .app-main {
    display: grid;
  }
  .app-sidebar {
    display: none;
  }
  .app-addbar {
    display: none;
  }
  /* .app-header{
        display:none;
        visibility: hidden;
    } */
}
</style>
